import React from 'react';

export const Skill = ({ data }) => {
    return <span className='skill'>{data}</span>;
};
